import React from 'react'
import ImageStore from '../../stores/image-store'
import OrderImagePreview from '../utils/order-image-preview'
import createReactClass from 'create-react-class'


var UpsalePreviewImage = createReactClass({
    imageLoading: false,
    mounted: false,

    getInitialState: function() {
        return { thumbImageSrc: null };
    },

    _loadImageSource: function() {
        var self = this,
            imageFilters = this.props.item.getImageFilters();

        if(!self.imageLoading) {
            self.imageLoading = true;
            var image = ImageStore.getImageById(self.props.imageId);
            if (image) {
                //todo Do we need it?
                image.setVisible(true);
                //Asyncronously fetch image src and then set state so that component will rerender and show image
                image.getSrcWithFilter(600, imageFilters).then (function (src) {
                  if (self.mounted) {
                    self.imageLoading = false;
                    self.setState({thumbImageSrc: src});
                  }
                })['catch'](function (err) {
                  displayError(_("Cannot show photo. Please try deleting and uploading it again and, if it still doesn’t show, please contact us for assistance."), {imageId: self.props.imageId, err: err});
                });
            } else {
                self.imageLoading = false;
            }
        }
    },

    componentDidMount: function () {
        this.mounted = true;
        this._loadImageSource();
    },
    render: function() {
        return (
            <div className="ope-upsale__group__images__container">
                <OrderImagePreview width={180} height={180} imageSource={this.state.thumbImageSrc} item={this.props.item}
                    wrapperClass="ope-upsale__group__images__wrapper"
                    imageClass="ope-upsale__group__image" />
            </div>
        );
    },
    componentWillUnmount: function () {
        this.mounted = false;
    }
});

export default UpsalePreviewImage;
